const expertUpgrade = {
  strings: {
    en: {
      loading: 'Looking up activation code...',
      channelTitle: 'Please contact your reseller to upgrade to Nessus Expert',
      channelSubtitle: 'It looks like you purchased this product from:',
      tryAgain: 'Try Again',
      buyLink: 'Buy Nessus Expert',
      badDataStatusCode: 422,
      badDataError: 'Bad data',
      badDataMessage: 'Please contact us',
      badDataEssentials: 'Your code cannot be upgraded',
      badDataEssentialsMsg: 'To get Nessus Expert, please purchase a new license',
      activationCodeLabel: 'Activation Code',
      submit: 'Lookup Activation Code',
    },
  },

  fireGTMEvent(category, action, label) {
    if (this.dev) { return; }

    /* eslint-disable no-undef */
    if (dataLayer) {
      dataLayer.push({
        event: 'gaEvent',
        eventCategory: category,
        eventAction: action,
        eventLabel: label,
      });
    }
    /* eslint-enable */
  },

  formSubmit(id) {
    const form = document.querySelector(`#${id}`);
    const code = this.escapeHTML(document.querySelector(`#${id}-code`).value);
    this.renderUpgradeAction(form, code, this.strings.en);
  },

  upgradeFormHTML(form, strings) {
    return `
    <div class="form-item">
      <label for="${form.id}-code" class="hidden">${strings.activationCodeLabel}</label>
      <input type="text" name="code" id="${form.id}-code" required>
    </div>
    <div class="wrap-btn textcenter">
      <input type="submit" id="${form.id}-submit" class="btn btn-large btn-block animated hmt" value="${strings.submit}">
    </div>
      `;
  },

  renderLoading(form, strings) {
    form.innerHTML = `
      <div class="expert-upgrade-loading textcenter">
        <div class="loader"></div>
        <h3>${strings.loading}</h3>
      </div>
    `;
  },

  renderResponse(form, response, strings, code) {
    const {
      success, distributors, ecom,
      statusCode = strings.badDataStatusCode, error = strings.badDataError, message = strings.badDataMessage,
    } = response;

    if (success && distributors && distributors.reseller) {
      const { name, website } = distributors.reseller;
      const webUrl = website && website.includes('http') ? website : `https://${website}`;
      this.fireGTMEvent('Nessus Expert Upgrade', 'reseller', name);
      form.innerHTML = `
        <div class="expert-upgrade-success textcenter">
          <h4>${strings.channelTitle}</h4>
          <p>${strings.channelSubtitle}</p>
          <h3 class="nomt">${name}</h3>
          <p><a target="_blank" rel="noopener nofollow" href="${webUrl}">${website}</a></p>
        </div>
      `;
    } else if (success && ecom && ecom.upgradeUrl) {
      this.fireGTMEvent('Nessus Expert Upgrade', 'ecom', ecom.subscriptionId);
      window.location.href = ecom.upgradeUrl;
    } else if (statusCode === 404 && message === 'Validation failed') {
      this.fireGTMEvent('Nessus Expert Upgrade', 'error', `${statusCode} - ${error}`);
      form.innerHTML = `
        <div class="expert-upgrade-error textcenter">
          <h4>${strings.badDataStatusCode} - ${strings.badDataEssentials}</h4>
          <h3 class="nomt mb">${strings.badDataEssentialsMsg}</h3>
          <a href="https://store.tenable.com/1479/purl-webExpertOneYearOptin?x-promotion=webupgrade&x-activation_code=${code}" class="btn btn-primary">${strings.buyLink}</a>
        </div>
      `;
    } else {
      this.fireGTMEvent('Nessus Expert Upgrade', 'error', `${statusCode} - ${error}`);
      form.innerHTML = `
        <div class="expert-upgrade-error textcenter">
          <h4>${statusCode} - ${error}</h4>
          <h3 class="nomt mb">${message}</h3>
          <button onclick="window.location.reload()" class="btn btn-primary-outline">${strings.tryAgain}</button>
        </div>
      `;
    }
  },

  makeUpgradeCall(code) {
    return fetch(`/evaluations/api/v1/nessus-expert/upgrade/${code}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json());
  },

  renderUpgradeAction(form, code, strings) {
    if (!code) {
      form.innerHTML = this.upgradeFormHTML(form, strings);
      document.querySelector(`#${form.id}-submit`).addEventListener('click', () => this.formSubmit(form.id));
      return;
    }

    this.renderLoading(form, strings);
    this.makeUpgradeCall(code)
      .then((upgradeCall) => {
        this.renderResponse(form, upgradeCall, strings, code);
      })
      .catch(() => {
        const errMsg = {
          success: false,
          statusCode: 403,
          error: 'CORS Error',
          message: 'Network Error',
        };
        this.renderResponse(form, errMsg, strings, code);
      });
  },

  escapeHTML(html) {
    const escape = document.createElement('textarea');
    escape.textContent = html;
    return escape.innerHTML;
  },

  getCode() {
    const url = new URL(window.location.href);
    return this.escapeHTML(url.searchParams.get('code'));
  },

  init() {
    const expertUpgradeDivs = document.querySelectorAll('[id^=t-expert-upgrade-]');

    if (expertUpgradeDivs.length > 0) {
      const code = this.getCode();

      expertUpgradeDivs.forEach((form) => this.renderUpgradeAction(form, code, this.strings.en));
    }
  },
};

expertUpgrade.init();
